/* globals _paq */
import { formatDefaultLocale } from 'd3-format';
import germanFormat from 'd3-format/locale/de-DE';
import { tsvParse } from 'd3-dsv';
import debounce from 'lodash.debounce';

germanFormat.percent = '';
germanFormat.currency = ['', ''];

const germanNumberFormat = formatDefaultLocale(germanFormat);

export function nf(num, format = ',', unit = false) {
  if (typeof num === 'undefined') {
    return '';
  }

  const formattedNumber = germanNumberFormat.format(format)(num);

  return unit ? `${formattedNumber} ${unit}` : formattedNumber;
}

export function trackEvent(name, data) {
  if (typeof _paq !== 'undefined') {
    _paq.push(['trackEvent', name, data, config.headline]);
  }
}

export async function loadCsv(src) {
  const response = await fetch(src);
  const csv = await response.text();
  const data = tsvParse(csv);
  return data;
}

export const translate = (x, y) => `translate(${x}, ${y})`;
export const translatePx = (x, y) => `translate(${x}px, ${y}px)`;

export const clamp = (num, min, max) =>
  num <= min ? min : num >= max ? max : num;

function resizeIframe() {
  const el = document.querySelector('.appwrapper');

  if (!el) {
    return;
  }

  const bounds = el.getBoundingClientRect();

  window.parent.postMessage(
    {
      idwAppFrameHeight: bounds.height,
    },
    '*'
  );
}

export const resizeIframeDebounced = debounce(resizeIframe, 100);

export function isIFrame() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export default {
  nf,
  trackEvent,
  translate,
  isIFrame,
  resizeIframeDebounced,
};
